
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppHeader } from './app-header.component';
import { AsideToggleDirectiveModule } from '../../directives/aside/aside.module';
import { SidebarDirectiveModule } from '../../directives/sidebar/sidebar.module';
import { NavDropdownDirectiveModule } from '../../directives/nav-dropdown/nav-dropdown.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
@NgModule({
  declarations: [
    AppHeader
  ],
  imports: [
    BrowserModule,
    AsideToggleDirectiveModule,
    SidebarDirectiveModule,
    NavDropdownDirectiveModule,
    BsDropdownModule.forRoot()
  ],
  exports: [
    AppHeader
  ]
})
export class AppHeaderModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/app-header/app-header.module.ts